import { RegisterTypeContainer } from "../../containers/RegisterSystem/RegisterTypeContainer";

export function RegisterTypePage() {

    return (
        <RegisterTypeContainer />
    );

}